<template>
  <div class="legal-page">
    <!-- Decorative background icons -->
    <div class="legal-page__decor legal-page__decor--left">
      <svg class="decor-icon decor-icon--1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1.5"/>
        <path d="M12 6v6l4 2" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
      </svg>
      <svg class="decor-icon decor-icon--2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <svg class="decor-icon decor-icon--3" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <svg class="decor-icon decor-icon--4" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="3" y="3" width="7" height="7" rx="1" stroke="currentColor" stroke-width="1.5"/>
        <rect x="14" y="3" width="7" height="7" rx="1" stroke="currentColor" stroke-width="1.5"/>
        <rect x="3" y="14" width="7" height="7" rx="1" stroke="currentColor" stroke-width="1.5"/>
        <rect x="14" y="14" width="7" height="7" rx="1" stroke="currentColor" stroke-width="1.5"/>
      </svg>
    </div>
    <div class="legal-page__decor legal-page__decor--right">
      <svg class="decor-icon decor-icon--5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M14 2v6h6M16 13H8M16 17H8M10 9H8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <svg class="decor-icon decor-icon--6" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="1.5"/>
        <path d="M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
      </svg>
      <svg class="decor-icon decor-icon--7" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z" stroke="currentColor" stroke-width="1.5"/>
        <path d="M3.27 6.96L12 12.01l8.73-5.05M12 22.08V12" stroke="currentColor" stroke-width="1.5"/>
      </svg>
      <svg class="decor-icon decor-icon--8" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 2a10 10 0 1010 10A10 10 0 0012 2zm0 14a1 1 0 110-2 1 1 0 010 2zm1-5a1 1 0 01-2 0V7a1 1 0 012 0z" stroke="currentColor" stroke-width="1.5"/>
      </svg>
    </div>
    <div class="legal-page__header">
      <button
        type="button"
        class="legal-page__back"
        aria-label="Go back"
        @click="goBack"
      >
        <i class="fas fa-arrow-left"></i>
      </button>
      <h1 class="legal-page__title">{{ translatedData?.modalTitle }}</h1>
    </div>
    <div class="legal-page__content">
      <p>
        <strong>{{ translatedData?.effectiveDate }}</strong>
      </p>
      <p>
        <strong>{{ translatedData?.importantNotice }}</strong>
      </p>
      <p>
        <strong>{{ translatedData?.platformNotice }}</strong>
      </p>
      <p>{{ translatedData?.welcomeMessage }}</p>
      <p>{{ translatedData?.termsAgreement }}</p>
      <p>{{ translatedData?.modificationsNotice }}</p>
      <p>
        <u><strong>{{ translatedData?.jointApplicantsTitle }}</strong></u>
        {{ translatedData?.jointApplicantsContent }}
      </p>
      <p>
        {{ translatedData?.contactInfo }}
        <a href="mailto:info@candid.inc">info@candid.inc</a>
      </p>

      <ol>
        <li><p>{{ translatedData?.eligibilityTitleScope }}</p></li>
      </ol>
      <p>
        <strong>{{ translatedData?.eligibilityTitle }}</strong>
        {{ translatedData?.eligibilityContent }}
      </p>
      <p>
        <strong>{{ translatedData?.restrictionsTitle }}</strong>
        {{ translatedData?.restrictionsDescription }}
      </p>

      <ol start="2">
        <li><p>{{ translatedData?.accountUseTitle }}</p></li>
      </ol>
      <p>
        <strong>{{ translatedData?.accountRegistrationTitle }}</strong>
        {{ translatedData?.accountRegistrationContent }}
      </p>
      <p>
        <strong>{{ translatedData?.unauthorizedUseTitle }}</strong>
        {{ translatedData?.unauthorizedUseContentTag }}
        <a href="mailto:info@candid.inc">info@candid.inc</a>
        {{ translatedData?.unauthorizedUseContentTagContent }}
      </p>

      <ol start="3">
        <li><p>{{ translatedData?.technicalRequirementsTitle }}</p></li>
      </ol>
      <p>{{ translatedData?.technicalRequirementsContent }}</p>

      <ol start="4">
        <li><p>{{ translatedData?.proprietaryRightsTitle }}</p></li>
      </ol>
      <p>
        <strong>{{ translatedData?.intellectualPropertyRightsTitle }}</strong>
        {{ translatedData?.intellectualPropertyRightsContent }}
      </p>
      <p>
        <strong>{{ translatedData?.useOfMarksTitle }}</strong>
        {{ translatedData?.useOfMarksContent }}
      </p>

      <ol start="5">
        <li><p>{{ translatedData?.authorizationToUseTitle }}</p></li>
      </ol>
      <p>
        <strong>{{ translatedData?.submittedInfoTitle }}</strong>
        {{ translatedData?.submittedInfoContent }}
      </p>
      <p>
        <strong>{{ translatedData?.accountInformationTitle }}</strong>
        {{ translatedData?.accountInformationContent }}
      </p>
      <p>{{ translatedData?.submittedInfoTransmission }}</p>
      <p>{{ translatedData?.limitedPowerOfAttorney }}</p>
      <p>
        <strong>{{ translatedData?.rightToProvideInfoTitle }}</strong>
        {{ translatedData?.rightToProvideInfoContent }}
      </p>
      <p>
        <strong>{{ translatedData?.feedbackTitle }}</strong>
        {{ translatedData?.feedbackContent }}
      </p>

      <ol start="6">
        <li><p>{{ translatedData?.yourLicenseProhibitedContent }}</p></li>
      </ol>
      <p>
        <strong>{{ translatedData?.yourLicenseTitle }}</strong>
        {{ translatedData?.yourLicenseContent }}
      </p>
      <p>
        <strong>{{ translatedData?.licenseGrantToCandidTitle }}</strong>
        {{ translatedData?.licenseGrantToCandidContent }}
      </p>
      <p>
        <strong>{{ translatedData?.prohibitedUsesTitle }}</strong>
        {{ translatedData?.prohibitedUsesContent }}
      </p>
      <ul>
        <li><p>{{ translatedData?.harass_abuse_threaten }}</p></li>
        <li><p>{{ translatedData?.unlawful_harmful_info }}</p></li>
        <li><p>{{ translatedData?.commercial_use }}</p></li>
        <li><p>{{ translatedData?.copy_modify_distribute }}</p></li>
        <li><p>{{ translatedData?.automated_access }}</p></li>
        <li><p>{{ translatedData?.bypass_restrictions }}</p></li>
        <li><p>{{ translatedData?.advocates_illegal_activity }}</p></li>
        <li><p>{{ translatedData?.malicious_software }}</p></li>
        <li><p>{{ translatedData?.disable_impair_platform }}</p></li>
        <li><p>{{ translatedData?.distribute_ip_without_right }}</p></li>
        <li><p>{{ translatedData?.confidential_info }}</p></li>
        <li><p>{{ translatedData?.false_affiliation }}</p></li>
        <li><p>{{ translatedData?.frame_display_platform }}</p></li>
        <li><p>{{ translatedData?.violate_terms }}</p></li>
        <li><p>{{ translatedData?.facilitate_violations }}</p></li>
        <li><p>{{ translatedData?.interfere_with_use }}</p></li>
      </ul>
      <p>{{ translatedData?.right_to_remove_block }}</p>

      <ol start="7">
        <li><p>{{ translatedData?.legal_compliance }}</p></li>
      </ol>
      <p>{{ translatedData?.candid_access_preserve_disclose }}</p>
      <p>{{ translatedData?.candid_no_professional_services }}</p>

      <ol start="8">
        <li><p>{{ translatedData?.warranties_disclaimers }}</p></li>
      </ol>
      <p>{{ translatedData?.use_at_own_risk }}</p>
      <p>{{ translatedData?.use_at_own_risk_content }}</p>
      <p>{{ translatedData?.download_at_own_risk }}</p>
      <p>{{ translatedData?.no_advice_creates_warranty }}</p>
      <p>{{ translatedData?.no_guarantees_results }}</p>

      <ol start="9">
        <li><p>{{ translatedData?.limitation_of_liability }}</p></li>
      </ol>
      <p>{{ translatedData?.no_liability_for_indirect_damages }}</p>
      <p>{{ translatedData?.release_from_third_party_disputes }}</p>

      <ol start="10">
        <li><p>{{ translatedData?.exclusions_limitations }}</p></li>
      </ol>
      <p>{{ translatedData?.jurisdictional_exclusions }}</p>

      <ol start="11">
        <li><p>{{ translatedData?.indemnity }}</p></li>
      </ol>
      <p>{{ translatedData?.user_agrees_to_indemnify }}</p>

      <ol start="12">
        <li><p>{{ translatedData?.thirdParty_links_platform }}</p></li>
      </ol>
      <p>{{ translatedData?.thirdParty_links_platform_content }}</p>

      <ol start="13">
        <li><p>{{ translatedData?.modification_and_termination }}</p></li>
      </ol>
      <p>
        <u><strong>{{ translatedData?.modification_of_platform }}</strong></u>
        {{ translatedData?.modification_of_platform_content }}
      </p>
      <p>
        <strong>{{ translatedData?.termination }}</strong>.
        {{ translatedData?.termination_content }}
      </p>

      <ol start="14">
        <li><p>{{ translatedData?.mandatory_arbitration_and_class_action_waiver }}</p></li>
      </ol>
      <p><strong>{{ translatedData?.mandatory_arbitration_content }}</strong></p>
      <p>
        <u><strong>{{ translatedData?.application }}</strong></u>
        {{ translatedData?.application_content }}
      </p>
      <p>
        <u><strong>{{ translatedData?.initial_dispute_resolution }}</strong></u>
        {{ translatedData?.initial_dispute_resolution_1 }}
        <a href="mailto:info@candid.inc">info@candid.inc</a>
        {{ translatedData?.initial_dispute_resolution_2 }}
      </p>
      <p>
        <u><strong>{{ translatedData?.binding_arbitration }}</strong></u>
        {{ translatedData?.binding_arbitration_content }}
      </p>
      <p>
        <u><strong>{{ translatedData?.arbitrators_powers }}</strong></u>
        {{ translatedData?.arbitrators_powers_content }}
      </p>
      <p>{{ translatedData?.arbitrators_powers_content1 }}</p>
      <p>{{ translatedData?.arbitrators_powers_content_2 }}</p>
      <p>
        <u><strong>{{ translatedData?.class_action_waiver }}</strong></u>
        {{ translatedData?.class_action_waiver_content }}
      </p>
      <p>
        <u><strong>{{ translatedData?.exception_litigation_of_intellectual_property_and_small_claims_court_claims }}</strong></u>
        {{ translatedData?.exception_litigation_content }}
      </p>
      <p>
        <u><strong>{{ translatedData?.thirty_day_right_to_opt_out }}</strong></u>
        {{ translatedData?.thirty_day_right_to_opt_out_content_1 }}
        <a href="mailto:info@candid.inc">info@candid.inc</a>
        {{ translatedData?.thirty_day_right_to_opt_out_content_2 }}
      </p>
      <p>
        <u><strong>{{ translatedData?.changes_to_this_section }}</strong></u>
        {{ translatedData?.changes_to_this_section_content }}
      </p>
      <p>
        <u><strong>{{ translatedData?.survival }}</strong></u>
        {{ translatedData?.survival_content }}
      </p>

      <ol start="15">
        <li><p>{{ translatedData?.controlling_law_and_severability }}</p></li>
      </ol>
      <p>{{ translatedData?.controlling_law_and_severability_content }}</p>

      <ol start="16">
        <li><p>{{ translatedData?.general_terms }}</p></li>
      </ol>
      <p>
        <u><strong>{{ translatedData?.force_majeure }}</strong></u>
        {{ translatedData?.force_majeure_content }}
      </p>
      <p>
        <u><strong>{{ translatedData?.no_waiver_severability }}</strong></u>
        {{ translatedData?.no_waiver_severability_content }}
      </p>
      <p>
        <u><strong>{{ translatedData?.third_party_beneficiaries }}</strong></u>
        {{ translatedData?.third_party_beneficiaries_content }}
      </p>
      <p>
        <u><strong>{{ translatedData?.statute_of_limitations }}</strong></u>
        {{ translatedData?.statute_of_limitations_content }}
      </p>
      <p>
        <u><strong>{{ translatedData?.miscellaneous }}</strong></u>
        {{ translatedData?.miscellaneous_content }}
      </p>
      <p>
        <u><strong>{{ translatedData?.notices }}</strong></u>
        {{ translatedData?.notices_content }}
        <a href="mailto:info@candid.inc">info@candid.inc</a>.
      </p>
      <p>
        {{ translatedData?.questions_content }}
        <a href="mailto:info@candid.inc">info@candid.inc</a>.
      </p>
    </div>
  </div>
</template>

<script>
import termsJson from "../data/termsJson";
import { translationMixin } from "../mixins/translationMixin";

export default {
  name: "TermsOfUsePage",
  mixins: [translationMixin],
  data() {
    return {
      data: termsJson,
      hasPreviousRoute: false,
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.hasPreviousRoute = Boolean(from && from.name);
    });
  },
  methods: {
    goBack() {
      if (this.hasPreviousRoute) {
        this.$router.back();
      } else {
        this.$router.push("/");
      }
    },
  },
};
</script>

<style scoped>
.legal-page {
  max-width: 960px;
  margin: 0 auto;
  padding: 40px 24px 80px;
  font-family: "Lato", sans-serif;
  color: #333;
  position: relative;
}

.legal-page__header {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 32px;
  padding-bottom: 16px;
  border-bottom: 3px solid var(--primary-color, #000);
}

.legal-page__back {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border: none;
  background: transparent;
  border-radius: 50%;
  color: var(--primary-color, #000);
  text-decoration: none;
  cursor: pointer;
  transition: background-color 0.2s;
  flex-shrink: 0;
  padding: 0;
}

.legal-page__back:hover {
  background-color: rgba(0, 0, 0, 0.06);
}

.legal-page__title {
  font-size: 24px;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0;
}

.legal-page__content {
  line-height: 1.7;
  text-align: justify;
}

.legal-page__content p {
  margin-bottom: 14px;
  font-size: 15px;
}

.legal-page__content ol,
.legal-page__content ul {
  margin-bottom: 10px;
  padding-left: 24px;
}

.legal-page__content ol > li > p {
  font-weight: 700;
  font-size: 16px;
  color: #1a1a1a;
}

.legal-page__content ul > li {
  margin-bottom: 4px;
}

.legal-page__content ul > li > p {
  margin-bottom: 4px;
}

.legal-page__content a {
  color: var(--primary-color, #000);
  text-decoration: underline;
}

.legal-page__content a:hover {
  opacity: 0.8;
}

/* Decorative Icons */
.legal-page__decor {
  position: fixed;
  top: 0;
  bottom: 0;
  width: 120px;
  pointer-events: none;
  z-index: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  padding: 80px 0;
}

.legal-page__decor--left {
  left: 20px;
}

.legal-page__decor--right {
  right: 20px;
}

.decor-icon {
  width: 44px;
  height: 44px;
  color: var(--primary-color, #000);
  opacity: 0.08;
}

.decor-icon--1 { transform: rotate(-15deg); opacity: 0.07; width: 40px; height: 40px; }
.decor-icon--2 { transform: rotate(10deg); opacity: 0.06; width: 48px; height: 48px; align-self: flex-end; }
.decor-icon--3 { transform: rotate(-5deg); opacity: 0.09; width: 36px; height: 36px; }
.decor-icon--4 { transform: rotate(20deg); opacity: 0.05; width: 42px; height: 42px; align-self: center; }
.decor-icon--5 { transform: rotate(8deg); opacity: 0.07; width: 46px; height: 46px; align-self: flex-start; }
.decor-icon--6 { transform: rotate(-12deg); opacity: 0.06; width: 38px; height: 38px; align-self: center; }
.decor-icon--7 { transform: rotate(15deg); opacity: 0.08; width: 50px; height: 50px; align-self: flex-end; }
.decor-icon--8 { transform: rotate(-8deg); opacity: 0.05; width: 34px; height: 34px; }

.legal-page__header,
.legal-page__content {
  position: relative;
  z-index: 1;
}

@media (max-width: 1200px) {
  .legal-page__decor {
    display: none;
  }
}

@media (max-width: 767px) {
  .legal-page {
    padding: 24px 16px 60px;
  }

  .legal-page__title {
    font-size: 20px;
  }

  .legal-page__content p {
    font-size: 14px;
  }
}
</style>
